<template>
   <div id="menupage" class="contact" @click="$emit('goto', -1)">
   <div class="portrait headline1">
      Læg venligst telefonen om på siden!
   </div>
   <div class="landscape contactframe" @click.stop="" @keydown.esc="$emit('goto', -1)" ref="focused" tabindex="0">
   <div class="closebutton">
      <span @click="$emit('goto', -1)">x</span>
   </div>
   <div class="headline1">{{ data.name }}</div>
   <div class="headline2"><a :href="'mailto:' + data.email" target="_blank">{{ data.email }}</a></div>
   <div class="headline2"><a :href="'tel:' + data.phone" target="_blank">Tel. {{ data.phone }}</a></div>
   <div class="headline2"><a :href="data.linkedin" target="_blank"><img src="https://albertusfilm.dk/drupal/sites/default/files/linkedin.png"></a></div>
   </div>
   </div>
</template>

<script>
export default {
  name: 'Contact',
  props: {
      data: Object
  },
   mounted() {
      // document.querySelector("#fullpage").style.backgroundImage="url(https://albertusfilm.dk/drupal/sites/default/files/styles/albertusbg/public/jabaggrundsbillede1.jpg?itok=5SGMMtTa) "
      document.querySelector("#fullpage").style.backgroundImage="url(https://albertusfilm.dk/drupal/sites/default/files/styles/albertusbg/public/jabaggrundsbillede1.jpg?itok=5SGMMtTa) "
      this.$refs.focused.focus();
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
